/**
 * Quick Shop modal for collection / search product grid cards.
 */
(function () {
  function getRootUrl() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root;
  }

  function bindQuickShop(card, rootUrl) {
    var host = card.querySelector('[data-frc-card]') || card;
    if (host.dataset.frcBound === '1') return;

    var modal = host.querySelector('[data-frc-modal]');
    var trigger = host.querySelector('[data-frc-quick-shop]');
    if (!modal || !trigger) return;
    host.dataset.frcBound = '1';

    if (!modal.dataset.frcPortaled) {
      document.body.appendChild(modal);
      modal.dataset.frcPortaled = '1';
    }

    var dialog = modal.querySelector('.frc-quick-shop__dialog');
    var imageEl = modal.querySelector('[data-frc-modal-image]');
    var priceEl = modal.querySelector('[data-frc-modal-price]');
    var compareEl = modal.querySelector('[data-frc-modal-compare]');
    var errorEl = modal.querySelector('[data-frc-modal-error]');
    var modalAddBtn = modal.querySelector('[data-frc-modal-add]');
    var swatchEls = Array.prototype.slice.call(modal.querySelectorAll('[data-frc-swatch]'));
    var groupValueEls = Array.prototype.slice.call(modal.querySelectorAll('[data-frc-group-value]'));

    var variants = [];
    var scriptEl = modal.querySelector('[data-frc-variants]');
    if (scriptEl) {
      try {
        variants = JSON.parse(scriptEl.textContent);
      } catch (err) {
        variants = [];
      }
    }

    var selected = [];
    var optionIndices = [];
    swatchEls.forEach(function (btn) {
      var i = parseInt(btn.getAttribute('data-option-idx'), 10);
      if (optionIndices.indexOf(i) === -1) optionIndices.push(i);
    });
    optionIndices.sort(function (a, b) {
      return a - b;
    });

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function optNormLocal(value) {
      return value == null ? '' : String(value).trim();
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options || [];
        var match = true;
        for (var k = 0; k < optionIndices.length; k++) {
          var oi = optionIndices[k];
          if (optNormLocal(opts[oi]) !== optNormLocal(values[oi])) {
            match = false;
            break;
          }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function getSelectedVariant() {
      return findVariant(selected);
    }

    function matchesPrior(variant, idx) {
      var opts = variant.options || [];
      for (var k = 0; k < optionIndices.length; k++) {
        var oi = optionIndices[k];
        if (oi >= idx) break;
        if (selected[oi] != null && optNormLocal(opts[oi]) !== optNormLocal(selected[oi])) {
          return false;
        }
      }
      return true;
    }

    function valueExists(idx, value, requireAvailable) {
      return variants.some(function (v) {
        if (!matchesPrior(v, idx)) return false;
        if (optNormLocal((v.options || [])[idx]) !== optNormLocal(value)) return false;
        return requireAvailable ? !!v.available : true;
      });
    }

    function firstValidValue(idx) {
      var anyValue = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!matchesPrior(v, idx)) continue;
        var val = (v.options || [])[idx];
        if (anyValue == null) anyValue = val;
        if (v.available) return val;
      }
      return anyValue;
    }

    function render() {
      var variant = getSelectedVariant();

      if (variant) {
        if (priceEl) {
          priceEl.textContent = variant.price || '';
          priceEl.classList.toggle('frc-quick-shop__price--sale', !!variant.compare);
        }
        if (compareEl) compareEl.textContent = variant.compare || '';
        if (variant.image && imageEl) imageEl.src = variant.image;
        if (modalAddBtn) {
          modalAddBtn.disabled = !variant.available;
          modalAddBtn.textContent = variant.available ? 'Add to Cart' : 'Out of Stock';
        }
        card.setAttribute('data-selected-variant-id', String(variant.id));
      } else if (modalAddBtn) {
        modalAddBtn.disabled = true;
        modalAddBtn.textContent = 'Unavailable';
      }

      groupValueEls.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-frc-group-value'), 10);
        el.textContent = selected[idx] || '';
      });

      swatchEls.forEach(function (btn) {
        var idx = parseInt(btn.getAttribute('data-option-idx'), 10);
        var value = btn.getAttribute('data-option-value');
        var active = optNormLocal(selected[idx]) === optNormLocal(value);
        btn.classList.toggle('frc-quick-shop__swatch--active', active);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');

        var exists = valueExists(idx, value, false);
        var hasStock = exists && valueExists(idx, value, true);
        btn.classList.toggle('frc-quick-shop__swatch--disabled', !exists);
        btn.classList.toggle('frc-quick-shop__swatch--sold-out', exists && !hasStock);
        if (!exists) btn.setAttribute('aria-disabled', 'true');
        else btn.removeAttribute('aria-disabled');
      });
    }

    function selectValue(idx, value) {
      clearError();
      if (!valueExists(idx, value, false)) return;
      selected[idx] = value;
      for (var k = 0; k < optionIndices.length; k++) {
        var oi = optionIndices[k];
        if (oi <= idx) continue;
        if (!valueExists(oi, selected[oi], false)) {
          selected[oi] = firstValidValue(oi);
        }
      }
      render();
    }

    function initSelection() {
      var first = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) {
          first = variants[i];
          break;
        }
      }
      if (!first) first = variants[0];
      selected = first && first.options ? first.options.slice() : [];
    }

    function closeAllModals() {
      document.querySelectorAll('[data-frc-modal]').forEach(function (m) {
        m.classList.remove('is-open');
        m.setAttribute('aria-hidden', 'true');
        m.hidden = true;
      });
      document.body.classList.remove('frc-quick-shop-open');
    }

    function openModal() {
      clearError();
      initSelection();
      render();
      closeAllModals();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('frc-quick-shop-open');
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      if (dialog) dialog.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('frc-quick-shop-open');
      window.setTimeout(function () {
        modal.hidden = true;
      }, 250);
      if (trigger && typeof trigger.focus === 'function') trigger.focus();
    }

    async function addToCart() {
      var variant = getSelectedVariant();
      if (!variant || !variant.available || !modalAddBtn) return;
      clearError();
      modalAddBtn.classList.add('is-loading');
      modalAddBtn.disabled = true;
      var previousLabel = modalAddBtn.textContent;
      modalAddBtn.textContent = 'Adding...';

      try {
        var res = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
        });
        if (!res.ok) {
          var payload = await res.json().catch(function () {
            return {};
          });
          throw new Error(payload.description || payload.message || 'Add to cart failed');
        }
        document.dispatchEvent(new CustomEvent('stylux:cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        closeModal();
      } catch (err) {
        showError(err.message || 'Something went wrong. Please try again.');
        modalAddBtn.textContent = previousLabel;
      } finally {
        modalAddBtn.classList.remove('is-loading');
        modalAddBtn.disabled = false;
      }
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!variants.length) return;
      openModal();
    });

    swatchEls.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('frc-quick-shop__swatch--disabled')) return;
        var idx = parseInt(btn.getAttribute('data-option-idx'), 10);
        selectValue(idx, btn.getAttribute('data-option-value'));
      });
    });

    modal.querySelectorAll('[data-frc-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    if (modalAddBtn) modalAddBtn.addEventListener('click', addToCart);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function initQuickShop(scope) {
    var root = scope || document;
    var rootUrl = getRootUrl();
    root.querySelectorAll('[data-quick-shop-card]').forEach(function (card) {
      bindQuickShop(card, rootUrl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initQuickShop();
    });
  } else {
    initQuickShop();
  }

  window.initProductGridQuickShop = initQuickShop;
})();
